export default "__VITE_ASSET__299ea793__"